import { NASELJA, NAZIVI_STANJA, NAZIVI_VEZE } from './konstante.js';
import { normalizirajTekst, provjeriKoordinate } from './evidencija.js';

export const PRAZNO_KUCANSTVO = {
  naselje: '',
  kucni_broj: '',
  opis_lokacije: '',
  nositelj_ime: '',
  nositelj_prezime: '',
  broj_prikljucaka: '1',
  godina_prikljucenja: '',
  stanje: 'aktivno',
  napomena: '',
  lat: '',
  lng: '',
  potvrdi_lokaciju: false,
};
export const noviKontakt = () => ({
  ime: '',
  prezime: '',
  veza: 'nositelj',
  telefon: '',
  email: '',
  telefon_nositelja: false,
  glavni: false,
});
export const ocistiTekst = (v) =>
  String(v ?? '')
    .trim()
    .replace(/\s+/g, ' ');
export const ocistiKucniBroj = (v) => ocistiTekst(v).replace(/\s+/g, '');
export function kljucAdrese(naselje, broj) {
  const cisti = ocistiKucniBroj(broj).toLowerCase();
  return cisti && cisti !== 'bb' ? `${naselje}|${cisti}`.toLowerCase() : null;
}
export function pronadjiDuplikat(podaci, kucanstva, izuzmiId = null) {
  const kljuc = kljucAdrese(podaci.naselje, podaci.kucni_broj);
  return kljuc
    ? (kucanstva.find(
        (k) =>
          k.id !== izuzmiId && kljucAdrese(k.naselje, k.kucni_broj) === kljuc,
      ) ?? null)
    : null;
}
export function provjeriKucanstvo(podaci, kontakti = []) {
  const greske = [];
  if (!NASELJA.some((n) => n.naziv === podaci.naselje))
    greske.push('Odaberi jedno od tri naselja vodovoda.');
  if (
    !ocistiTekst(podaci.nositelj_ime) ||
    !ocistiTekst(podaci.nositelj_prezime)
  )
    greske.push('Upiši ime i prezime nositelja.');
  if (
    !kljucAdrese(podaci.naselje, podaci.kucni_broj) &&
    !ocistiTekst(podaci.opis_lokacije)
  )
    greske.push(
      'Za adresu bez kućnog broja ili s oznakom bb obavezan je opis lokacije.',
    );
  if (
    !/^\d+$/.test(String(podaci.broj_prikljucaka)) ||
    Number(podaci.broj_prikljucaka) > 20
  )
    greske.push('Broj priključaka mora biti cijeli broj od 0 do 20.');
  if (
    String(podaci.godina_prikljucenja ?? '') &&
    (!/^\d{4}$/.test(String(podaci.godina_prikljucenja)) ||
      Number(podaci.godina_prikljucenja) < 1970 ||
      Number(podaci.godina_prikljucenja) > 2100)
  )
    greske.push('Godina priključenja mora biti između 1970. i 2100.');
  if (!Object.hasOwn(NAZIVI_STANJA, podaci.stanje))
    greske.push('Odaberi stanje kućanstva.');
  if (String(podaci.lat ?? '').trim() || String(podaci.lng ?? '').trim()) {
    try {
      provjeriKoordinate(podaci.lat, podaci.lng);
    } catch (e) {
      greske.push(e.message);
    }
  }
  if (kontakti.length > 20)
    greske.push('Kućanstvo može imati najviše 20 kontakata u jednom unosu.');
  if (kontakti.filter((k) => k.glavni).length > 1)
    greske.push('Odaberi samo jedan glavni kontakt.');
  kontakti.forEach((k, i) => {
    if (!ocistiTekst(k.ime) || !ocistiTekst(k.prezime))
      greske.push(`Kontakt ${i + 1}: upiši ime i prezime.`);
    if (!Object.hasOwn(NAZIVI_VEZE, k.veza))
      greske.push(`Kontakt ${i + 1}: odaberi vezu s nositeljem.`);
    if (
      ocistiTekst(k.email) &&
      !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(k.email.trim())
    )
      greske.push(`Kontakt ${i + 1}: provjeri e-mail adresu.`);
    if (
      ocistiTekst(k.telefon) &&
      (!/^\+?[\d\s()./-]+$/.test(k.telefon.trim()) ||
        k.telefon.replace(/\D/g, '').length < 8 ||
        k.telefon.replace(/\D/g, '').length > 15)
    )
      greske.push(
        `Kontakt ${i + 1}: provjeri telefonski broj (8–15 znamenki).`,
      );
  });
  return greske;
}
export function pripremiZaSpremanje(podaci, kontakti) {
  const greske = provjeriKucanstvo(podaci, kontakti);
  if (greske.length) throw new Error(greske.join(' '));
  const koordinate =
    String(podaci.lat ?? '').trim() || String(podaci.lng ?? '').trim()
      ? provjeriKoordinate(podaci.lat, podaci.lng)
      : [null, null];
  return {
    podaci: {
      ...PRAZNO_KUCANSTVO,
      ...podaci,
      kucni_broj: ocistiKucniBroj(podaci.kucni_broj),
      nositelj_ime: ocistiTekst(podaci.nositelj_ime),
      nositelj_prezime: ocistiTekst(podaci.nositelj_prezime),
      opis_lokacije: ocistiTekst(podaci.opis_lokacije),
      napomena: String(podaci.napomena ?? '').trim(),
      broj_prikljucaka: Number(podaci.broj_prikljucaka),
      godina_prikljucenja: podaci.godina_prikljucenja
        ? Number(podaci.godina_prikljucenja)
        : null,
      lat: koordinate[0],
      lng: koordinate[1],
      potvrdi_lokaciju: !!podaci.potvrdi_lokaciju,
    },
    kontakti: kontakti.map((k) => ({
      ...k,
      ime: ocistiTekst(k.ime),
      prezime: ocistiTekst(k.prezime),
      email: ocistiTekst(k.email),
      telefon: ocistiTekst(k.telefon),
    })),
  };
}
export function podaciZaObrazac(zapis) {
  return Object.fromEntries(
    Object.entries(PRAZNO_KUCANSTVO).map(([kljuc, prazno]) => [
      kljuc,
      kljuc === 'potvrdi_lokaciju'
        ? false
        : zapis[kljuc] == null
          ? prazno
          : String(zapis[kljuc]),
    ]),
  );
}
function udaljenost(a, b) {
  const rad = (v) => (Number(v) * Math.PI) / 180;
  const razlika =
    Math.sin(rad(b.lat - a.lat) / 2) ** 2 +
    Math.cos(rad(a.lat)) *
      Math.cos(rad(b.lat)) *
      Math.sin(rad(b.lng - a.lng) / 2) ** 2;
  return 6371000 * 2 * Math.atan2(Math.sqrt(razlika), Math.sqrt(1 - razlika));
}
export function slicnaKucanstva(podaci, kucanstva, izuzmiId = null) {
  const osnovni = ocistiKucniBroj(podaci.kucni_broj).match(/^\d+/)?.[0];
  return kucanstva
    .filter((k) => {
      if (k.id === izuzmiId) return false;
      if (
        podaci.lat !== '' &&
        podaci.lng !== '' &&
        k.lat != null &&
        k.lng != null &&
        Number.isFinite(Number(podaci.lat)) &&
        Number.isFinite(Number(podaci.lng)) &&
        udaljenost(podaci, k) < 15
      )
        return true;
      return (
        podaci.naselje === k.naselje &&
        ((osnovni &&
          osnovni === String(k.kucni_broj ?? '').match(/^\d+/)?.[0]) ||
          (ocistiTekst(podaci.nositelj_prezime).length > 2 &&
            normalizirajTekst(podaci.nositelj_prezime) ===
              normalizirajTekst(k.nositelj_prezime)))
      );
    })
    .slice(0, 5);
}
